<template>
  <FITModal ref="CURDModal" :title="action" reference="Modal" @click="modalAction">
    <div slot="body">
      <template>
        <div>
          <!-- Retrieve Section (Array Type)-->
          <div v-if="action == 'retrieve'" v-for="item in data">
            <h5 class="d-block py-1 lightFontWeight">{{item.key}}</h5>
            <h5 class="d-block py-1 bottomBorder">{{item.value}}</h5>
          </div>
          <!-- Create Section -->
          <div v-if="action == 'create'" v-for="column in columns">
            <h5 class="d-block lightFontWeight">{{column}}</h5>
            <div v-if="column != 'ID'">
              <FITTextInput v-model="formData.dataList[column]"></FITTextInput>
            </div>
          </div>
          <!-- Delete Section -->
          <div v-if="action == 'delete'">
            <h5 class="d-block py-1 lightFontWeight">
          		{{this.$t('general.CURD.deleteConfirmMessage')}}
          	</h5>
          </div>
          <!-- Update Section (Object Type)-->
          <div v-if="action == 'update'" v-for="item in data">
            <h5 class="d-block lightFontWeight">{{item.key}}</h5>
            <div v-if="item.key == 'ID'">
              <h5 class="d-block py-1 lightFontWeight">{{formData.dataList[item.key]}}</h5>
            </div>
            <div v-else>
              <FITTextInput v-model="formData.dataList[item.key]"></FITTextInput>
            </div>
          </div>
        </div>
      </template>
    </div>
  </FITModal>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITModal, FITTextInput } from '@/components'
import { has } from 'lodash' // import lodash
import $ from 'jquery'

export default {
  name: 'CURDModal',
  components: {
    FITModal,
    FITTextInput
  },
  data() {
    return {
      action: '',
      formData: {
        columns: [],
        dataList: {},
      },
    }
  },
  computed: {
    data() { // For Retrieve and Update Actions

      var data = this.$store.state.EntityManagement.dataAction.data;
      var dataArray = [];
      $.each(data, (key, value) => {
        // console.log(key,value);
        dataArray.push({ key: key, value: value }); //Array type
        this.formData.dataList[key] = value; //Object type
      });
      return dataArray;
    },
    columns() { // For Create Action
      var columns = this.$store.state.EntityManagement.dataList.columns;
      $.each(columns, (key, value) => {
        // console.log(key,value);
        this.formData.columns.push(value);
        this.formData.dataList[value] = '';
      });
      return columns;
    },
  },
  mounted() {
    // console.log(this.formData)
  },
  methods: {
    openCURDModal(value) {
      this.action = value.action;
      this.$store.commit('EntityManagement/updateActionID', value);
      console.log(value);
      switch (value.action) {
        case 'retrieve':
        case 'update':
          this.$store.dispatch('EntityManagement/retrieveDataRecord');
          break;
        case 'delete':
        case 'create':
        default:
          break;
      }
      this.$refs.CURDModal.openModal();
    },
    modalAction(value) {
      // console.log(value);
      if (value) {
        switch (this.action) {
          case 'create':
            // console.log(this.formData.dataList);
            this.$store.dispatch('EntityManagement/createDataRecord', this.formData.dataList);
            break;
          case 'update':
            this.$store.dispatch('EntityManagement/updateDataRecord', this.formData.dataList);
            break;
          case 'delete':
            this.$store.dispatch('EntityManagement/deleteDataRecord');
            break;
          case 'retrieve':
            break;

        }
      }
    },

  }
}

</script>
<style type="text/css">


</style>



// WEBPACK FOOTER //
// src/Adm/EntityManagement/components/CURDModal.vue